import {
  PersonProfileService,
  InternalPersonProfileService,
} from '@openeducation/oe-it-services';

import { usePersonProfileNoService } from './use-person-profile-no-service';

type ServiceType = 'internal-profile' | 'profile' | 'monitor-profile';

export interface TeacherProps {
  personId: number | undefined;
  service?: ServiceType;
}

export const usePersonProfile = ({
  personId,
  service = 'profile',
}: TeacherProps) => {
  const {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  } = usePersonProfileNoService({
    personId,
    extraQueryKey: service,
    getProfileById: (env, personId) => {
      switch (service) {
        case 'internal-profile':
          return InternalPersonProfileService.getProfileById(env, personId);
        case 'monitor-profile':
          return PersonProfileService.getLiteProfileMonitorById(env, personId);
        case 'profile':
        default:
          return PersonProfileService.getProfileById(env, personId);
      }
    },
  });

  return {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  };
};
